import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'app-dharura-tgsd',
  templateUrl: './dharura-tgsd.component.html',
  styleUrl: './dharura-tgsd.component.scss'
})
export class DharuraTgsdComponent {
  hudumaList = [
    {name: 'Victoria, Maziwa mengine na Bahari', namba: '110', icon: 'polisi'},
    {name: 'Polisi', namba: '112', icon: 'polisi'},
    {name: 'Zimamoto na Uokoaji', namba: '114', icon: 'moto'},
    {name: 'Dharura kwa Mtoto', namba: '116', icon: 'jinsiaWatoto'},
    {name: 'Kupambana na madawa ya kulevya', namba: '119', icon: 'uhalifu'},
    {name: 'Kupinga biashara haramu ya kusafirisha binadamu', namba: '195', icon: 'uhalifu'},
    {name: 'Kuzuia Uhalifu', namba: '111', icon: 'uhalifu'},
    {name: 'Rushwa', namba: '113', icon: 'rushwa'},
    {name: 'Gari la Wagonjwa', namba: '115', icon: 'ambulance'},
    {name: 'Huduma za VVU na UKIMWI', namba: '117', icon: 'afya'},
    {name: 'Huduma za Maafa', namba: '190', icon: 'afya'},
    {name: 'Magonjwa ya Mlipuko', namba: '199', icon: 'afya'},

  ];

  @Output() exitHover = new EventEmitter();

}
